<template>
  <div id="checkout">
    <div class="container">
      <div class="row">
        <div :class="['checkout-col col-md-8', sideCartVisible ? 'not-visible' : '']">
          <div class="checkout-form">
            <div class="mobile see-cart btn btn-sm btn-danger" @click="sideCartVisible = !sideCartVisible">
              Check Cart <i class="fa fa-arrow-right"></i>
            </div>
            <div class="box">
              <h2 class="section-title">Order Type</h2>
              <b-form-radio-group id="radios2" class="radio-boxes" v-model="orderType">
                <b-form-radio :class="[orderType === 'collection' ? 'is-checked' : '']" value="collection">
                  Collection
                  <span class="sublabel">Will be available for collection in 20 minutes</span>
                </b-form-radio>
                <b-form-radio v-if="location.id === 1 && websiteAvailability.canDoDelivery && currentHour+''+currentMinute >= '1600'" :class="[orderType === 'delivery' ? 'is-checked' : '']" value="delivery">
                  Delivery <span class="subtitle">(min. £ {{ minimumForDelivery.toFixed(2) }})</span>
                  <span class="sublabel" v-if="currentHour+''+currentMinute >= '1900'  && currentHour+''+currentMinute <= '2200'" >Will be delivered between in 50 minutes - 1h</span>
                  <span class="sublabel" v-else>Will be delivered within 45min</span>
                </b-form-radio>
                <b-form-radio v-if="location.id === 2 && websiteAvailability.canDoDelivery && currentHour+''+currentMinute >= '1600'" :class="[orderType === 'delivery' ? 'is-checked' : '']" value="delivery">
                  Delivery <span class="subtitle">(min. £ {{ minimumForDelivery.toFixed(2) }})</span>
                  <span class="sublabel" v-if="currentHour+''+currentMinute >= '1900'  && currentHour+''+currentMinute <= '2200'" >Will be delivered within 45min - 1h</span>
                  <span class="sublabel" v-else>Will be delivered in about 35-50 mins</span>
                </b-form-radio>
              </b-form-radio-group>
            </div>
            <div class="box">
              <h2 class="section-title">Customer Details</h2>
              <div class="row" v-if="!token || !user.phone || (orderType === 'delivery' && (!user.address1 || !user.postcode))">
                <div class="col-md-12" v-if="!token && orderType !== 'delivery'">
                  <b-form-radio-group id="checkoutModeBoxes" class="radio-boxes" v-model="checkoutMode">
                    <b-form-radio :class="[checkoutMode === 'account' ? 'is-checked' : '']" value="account">
                      Create an Account
                      <span class="sublabel">Save your details for future orders</span>
                    </b-form-radio>
                    <b-form-radio :class="[checkoutMode === 'guest' ? 'is-checked' : '']" value="guest">
                      Guest Checkout
                      <span class="sublabel">No account needed — quick and easy</span>
                    </b-form-radio>
                  </b-form-radio-group>
                </div>
                <div class="col-md-12" v-if="!token && checkoutMode === 'account'">
                  <p class="alert alert-warning">
                    After you will submit the checkout, a Kungfood account will be created for you.<br>
                    If you already have an account, <router-link to="/profile"><u>please Sign in</u></router-link>.
                  </p>
                </div>
                <div class="col-md-12" v-if="isGuestMode">
                  <p class="text-muted small-text guest-note">
                    Your details are taken from your payment — nothing to type in.
                    Already have an account? <router-link to="/profile"><u>Sign in</u></router-link>.
                  </p>
                </div>
                <div class="col-md-12">
                  <form autocomplete="off">
                    <div class="row" v-if="!token && !isGuestMode">
                      <div class="col-md-6">
                        <div :class="[firstName ? 'show-label' : '', 'form-group']" >
                          <label>First Name</label>
                          <input type="text" class="form-control" autocomplete="off" placeholder="First Name" v-model="firstName"/>
                          <h6 class="text-danger small" v-if="formError">{{ formError.firstName }}</h6>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div :class="[lastName ? 'show-label' : '', 'form-group']">
                          <label>Last Name</label>
                          <input type="text" autocomplete="off" class="form-control" placeholder="Last Name" v-model="lastName"/>
                          <h6 class="text-danger small" v-if="formError">{{ formError.lastName }}</h6>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6" v-if="!token && !isGuestMode">
                        <div :class="[email ? 'show-label' : '', 'form-group']">
                          <label>Email</label>
                          <input type="text" autocomplete="off" class="form-control" placeholder="Email" v-model="email"/>
                          <h6 class="text-danger small" v-if="formError">{{ formError.email }}</h6>
                        </div>
                      </div>
                      <div class="col-md-6" v-if="(!user || (user && !user.phone)) && !isGuestMode">
                        <div :class="[phone ? 'show-label' : '', 'form-group']">
                          <label>Phone</label>
                          <input type="text" autocomplete="off" class="form-control" placeholder="Phone" v-model="phone"/>
                          <h6 class="text-danger small" v-if="formError">{{ formError.phone }}</h6>
                        </div>
                      </div>
                    </div>
                    <div class="row" v-if="!token && checkoutMode === 'account'">
                      <div class="col-md-6">
                        <div :class="[password ? 'show-label' : '', 'form-group']">
                          <label>Password</label>
                          <input type="password" autocomplete="off" class="form-control" placeholder="Password" v-model="password"/>
                          <h6 class="text-danger small" v-if="formError">{{ formError.password }}</h6>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div :class="[passwordConfirmation ? 'show-label' : '', 'form-group']">
                          <label>Password Confirmation</label>
                          <input type="password" autocomplete="off" class="form-control" placeholder="Password Confirmation" v-model="passwordConfirmation" />
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-3" v-if="orderType === 'delivery'">
                        <div :class="[postcode ? 'show-label' : '', 'form-group']">
                          <label>Delivery Postcode</label>
                          <input type="text" autocomplete="off" class="form-control" placeholder="Delivery Postcode" v-model="postcode"/>
                          <h6 class="text-danger small" v-if="formError">{{ formError.postcode }}</h6>
                        </div>
                      </div>
                      <div class="col-md-9" v-if="orderType === 'delivery'">
                        <div :class="[address ? 'show-label' : '', 'form-group']">
                          <label>Delivery Address</label>
                          <input type="text" autocomplete="off" class="form-control" placeholder="Delivery Address" v-model="address"/>
                          <h6 class="text-danger small" v-if="formError">{{ formError.address }}</h6>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
              <div class="row" v-else>
                <div class="col-md-12">
                  <div class="user-static-details">
                    <div class="row">
                      <div class="col-md-6 ">
                        <h4>{{ user.first_name }} {{ user.last_name }}</h4>
                        {{ user.phone }}<br>
                        {{ user.email }}
                      </div>
                      <div class="col-md-6" v-if="orderType === 'delivery'">
                        <div class="text-muted">Shipping Details</div>
                        {{ user.address1 }}<br>
                        {{ user.postcode }}<br>
                        London, United Kingdom
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box">
              <h2 class="section-title">Discount</h2>
              <div class="row">
                <div class="col-md-12">
                  <div :class="[coupon_code ? 'show-label' : '', 'form-group coupon-input']">
                    <label>Coupon Code</label>
                    <input type="text" autocomplete="off" class="form-control" placeholder="Coupon Code" v-model="coupon_code" />
                  </div>
                  <div :class="[coupon_code ? 'keep-top' : '','btn btn-danger coupon-btn btn-fill']" @click="applyCoupon()">Apply Coupon</div>
                </div>
              </div>
            </div>
            <form method="post" id="payment-form" autocomplete="off">
              <div class="box">
                <h2 class="section-title">Note</h2>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <textarea class="form-control" placeholder="Leave a note..." rows="5" v-model="note"></textarea>
                      <h6 class="text-danger small" v-if="formError">{{ formError.note }}</h6>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box">
                <h2 class="section-title">Payment</h2>
                <div class="row" v-if="canUseWallet">
                  <div class="col-md-12">
                    <b-form-radio-group id="paymentTypeBoxes" class="radio-boxes" v-model="paymentType">
                      <b-form-radio :class="[paymentType === 'card' ? 'is-checked' : '']" value="card">
                        Card
                        <span class="sublabel">Pay with your bank card</span>
                      </b-form-radio>
                      <b-form-radio :class="[paymentType === 'wallet' ? 'is-checked' : '']" value="wallet">
                        {{ walletLabel }}
                        <span class="sublabel">Fast checkout — details shared automatically</span>
                      </b-form-radio>
                    </b-form-radio-group>
                  </div>
                </div>
                <div class="row" v-if="paymentType === 'wallet' && !walletReady">
                  <div class="col-md-12">
                    <div class="wallet-hint">Please sign in to pay with {{ walletLabel }} for delivery orders</div>
                  </div>
                </div>
<!--                <b-form-radio-group id="radios2" class="radio-boxes mb-15" v-model="paymentType" @change="changePaymentType">-->
<!--                  <b-form-radio :class="[paymentType === 'card' ? 'is-checked' : '']" value="card">-->
<!--                    Pay by card-->
<!--                    <span class="sublabel">Hassle free</span>-->
<!--                  </b-form-radio>-->
<!--                  <b-form-radio :class="[paymentType === 'cash' ? 'is-checked' : '']" value="cash">-->
<!--                    Pay by cash-->
<!--                    <span class="sublabel" v-if="orderType == 'collection'">Queue and pay when you arrive at the shop</span>-->
<!--                    <span class="sublabel" v-else>Deal with changes and pay to the courier</span>-->
<!--                  </b-form-radio>-->
<!--                </b-form-radio-group>-->
                <div class="row">
                  <div class="col-md-12" v-if="paymentErrorMessage">
                    <p class="alert alert-danger">
                      {{ paymentErrorMessage }}
                    </p>
                  </div>
                </div>
                <template v-if="showCardForm">
                  <div class="row" v-show="paymentType === 'card'" v-if="hasCard === false">
                    <div class="col-md-12" v-if="!billingAsShipping">
                      <div :class="[billing.nameOnCard ? 'show-label' : '', 'form-group']">
                        <label>Name on card</label>
                        <input type="text" autocomplete="off" class="form-control" placeholder="Name on card"
                               v-model="billing.nameOnCard"/>
                        <h6 class="text-danger small" v-if="billingError.nameOnCard">{{ billingError.nameOnCard }}</h6>
                      </div>
                    </div>
                    <div class="col-md-3" v-if="(orderType === 'collection' && !token) || !billingAsShipping || (token && orderType === 'collection' && (!user.postcode || !user.address1))">
                      <div :class="[billing.postcode ? 'show-label' : '', 'form-group']">
                        <label>Billing Postcode</label>
                        <input type="text" autocomplete="off" class="form-control" placeholder="Billing Postcode"
                               v-model="billing.postcode" />
                        <h6 class="text-danger small" v-if="billingError.postcode">{{ billingError.postcode }}</h6>
                      </div>
                    </div>
                    <div class="col-md-9" v-if="(orderType === 'collection' && !token) || !billingAsShipping || (token && orderType === 'collection' && (!user.postcode || !user.address1))">
                      <div :class="[billing.address ? 'show-label' : '', 'form-group']">
                        <label>Billing Address</label>
                        <input type="text" autocomplete="off" class="form-control" placeholder="Billing Address"
                               v-model="billing.address" />
                        <h6 class="text-danger small" v-if="billingError.address">{{ billingError.address }}</h6>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-row">
                        <div id="card-element">
                          <!-- A Stripe Element will be inserted here. -->
                        </div>

                        <!-- Used to display form errors. -->
                        <h6 class="text-danger small" id="card-errors" role="alert"></h6>
                      </div>

                      <div class="row mt-3">
                        <div class="col-md-6" v-if="orderType === 'delivery'">
                          <div class="checkbox-box">
                            <b-form-checkbox :class="[billingAsShipping ? 'is-checked' : '']"
                                             id="billingAsShippingCheckbox"
                                             v-model="billingAsShipping" :value="true" :unchecked-value="false">
                              Billing details are same as shipping
                            </b-form-checkbox>
                          </div>
                        </div>
                        <div class="col-md-6" v-if="token || checkoutMode === 'account'">
                          <div class="checkbox-box">
                            <b-form-checkbox :class="[saveCard ? 'is-checked' : '']" id="saveCardCheckbox"
                                             v-model="saveCard" :value="true" :unchecked-value="false">
                              Save time and store card for future orders
                            </b-form-checkbox>
                          </div>
                        </div>
                      </div>
                      <br>
                      <br>
                    </div>
                  </div>
                  <div class="row" v-show="paymentType === 'card'" v-else>
                    <div class="col-md-12">
                      <div class="payment-sources">
                        <div class="source" v-for="source in sources">
                          <div class="card-logo">
                            <img src="../../assets/img/cards/visa.png" />
                          </div>
                          <div class="card-numbers">
                            <div class="text-muted">Card Number</div>
                            <span>****</span>
                            <span>****</span>
                            <span>****</span>
                            <span>{{ source.last4 }}</span>
                          </div>
                          <div class="card-year">
                            <div class="text-muted">Expire Year</div>
                            {{ source.exp_year }}
                          </div>
                        </div>
                      </div>
                      <div class="add-new-card text-muted" @click="addNewCard()">Add new card</div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="box">
                <div class="row">
                  <div class="col-md-12">
                    <b-button v-if="paymentType === 'card'" class="btn-default btn-fill mt-3" :disabled="!cart.length || !websiteAvailability.isOpen || !websiteAvailability.canTakeOrders || (orderType === 'delivery' && getCartTotal < minimumForDelivery)" type="submit">Checkout</b-button>
                    <div id="express-checkout-element" class="mt-3" v-show="paymentType === 'wallet' && canUseWallet && walletReady"></div>
                    <h6 class="text-danger small" v-if="orderType === 'delivery' && getCartTotal < minimumForDelivery">
                      Minimum order for delivery is £{{ minimumForDelivery.toFixed(2) }}
                    </h6>
                    <h6 class="text-danger small" v-if="!websiteAvailability.isOpen || !websiteAvailability.canTakeOrders">
                      We are sorry but we do not take orders at this moment.
                      {{ websiteAvailability.canTakeOrders && !websiteAvailability.isOpen ? `Come back please${websiteAvailability.nextOpeningDay ? ' on ' + websiteAvailability.nextOpeningDay : ''} at ${websiteAvailability.nextOpeningHour}` : '' }}
                    </h6>
                    <h6 class="text-danger small" v-if="bottomError">
                      {{ bottomError }}
                    </h6>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <div :class="['half-side cart', sidebarOnAbsolute ? 'on-absolute' : '', sideCartVisible ? 'visible' : '']">
      <div class="items">
        <div class="mobile cart-back btn btn-sm btn-default" @click="sideCartVisible = !sideCartVisible"><i class="fa fa-arrow-left"></i> Checkout</div>
        <h2 class="section-title">Your Cart</h2>
        <div class="products">
          <div v-for="(row, index) in cart" class="product">
            <div class="image">
              <img :src="row.image" v-if="row.image && row.image !== ''" :alt="row.title"/>
              <img src="../../assets/img/food.png" v-else :alt="row.title"/>
            </div>
            <div class="details">
              <div class="title">{{ row.title }}{{ row.type === 'offer' ? ' (Lunch Box)' : '' }}</div>
              <div class="quantity">
                <div class="pull-left">x {{ row.quantity }}</div>
                <div class="pull-left change-quantity">
                  <span class="plus" @click="plusProductQuantity(index)">+</span>
                  <span class="minus" @click="minusProductQuantity(index)">-</span>
                </div>

                <div class="pull-right">£{{ (row.discount > 0 ? row.discount : row.price).toFixed(2) }}</div>
                <div class="clearfix"></div>
              </div>
              <div v-if="row.type === 'offer'" class="lunch-box-items">
                <div v-for="item in row.items" class="lunch-box-item">
                  <div class="category-title">{{ item.category_title }}</div>
                  <div v-for="product in item.products" class="product">{{ product.title }}</div>
                </div>
                <div v-if="row.note" class="category-title">Note</div>
                <div class="product">{{ row.note }}</div>

              </div>
            </div>
            <div class="delete" @click="deleteProductFromCart(index)">
              <i class="fa fa-trash"></i>
            </div>
          </div>
        </div>
        <div class="totals">
          <div class="total-row">
            <div class="pull-left">Subtotal</div>
            <div class="pull-right text-right">£{{ getCartTotal.toFixed(2) }}</div>
            <div class="clearfix"></div>
          </div>
          <div class="total-row" v-if="discount.amount">
            <div class="pull-left">Discount</div>
            <div class="pull-right text-right">
              <span class="text-danger small-text" v-if="discountThreshold > 0 && getCartTotal < discountThreshold">
                Not applied for orders under £{{discountThreshold}}
              </span>
              {{ discount.amount }}{{ discount.type }}
            </div>
            <div class="clearfix"></div>
          </div>
          <div class="total-row" v-if="orderType === 'delivery'">
            <div class="pull-left">Delivery</div>
            <div class="pull-right text-right">{{ deliveryCost == 0 ? 'Free' : '£' + deliveryCost.toFixed(2) }}</div>
            <div class="clearfix"></div>
          </div>
          <div class="total-row" v-if="adminFee > 0 && cartTotalBeforeAdminFee > 0 && cartTotalBeforeAdminFee < 10">
            <div class="pull-left">Admin Fee</div>
            <div class="pull-right text-right">£{{ adminFee.toFixed(2) }}</div>
            <div class="clearfix"></div>
          </div>
          <div class="total-row">
            <div class="pull-left">Total</div>
            <div class="pull-right text-right">£{{ getCartFinalTotal.toFixed(2) }}</div>
            <div class="clearfix"></div>
          </div>
          <p class="text-muted small-text"><span class="text-red">*</span> For orders under £10.00 is set an £{{ adminFee.toFixed(2) }} admin fee and the discount is not applied.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapGetters} from 'vuex'
  import env from '../../env.json'

  let stripe = null
  let card = null
  let expressStripe = null
  let expressElements = null
  let expressCheckout = null

  let kf
  export default {
    name: 'checkout',
    data () {
      return {
        base_url: env.base_url,
        orderType: this.$store.getters.getOrderType,
        paymentType: 'card',
        checkoutMode: 'account',
        walletType: null,
        firstName: null,
        lastName: null,
        password: null,
        passwordConfirmation: null,
        email: null,
        phone: null,
        postcode: null,
        address: null,
        note: null,
        formError: null,
        topError: null,
        sources: null,
        bottomError: null,
        billing: {
          nameOnCard: null,
          postcode: null,
          address: null
        },
        billingError: {
          nameOnCard: null,
          postcode: null,
          address: null
        },

        saveCard: true,
        hasCard: null,
        sidebarOnAbsolute: false,
        billingAsShipping: true,
        paymentErrorMessage: null,
        coupon_code: null,

        currentHour: (new Date()).getHours(),
        currentMinute: (new Date()).getMinutes() < 9 ? '0' + (new Date()).getMinutes() : (new Date()).getMinutes(),
        sideCartVisible: false,
        canUseWallet: false
      }
    },
    computed: {
      ...mapState({
        token: state => state.token,
        user: state => state.user,
        cart: state => state.cart,
        deliveryCost: state => state.deliveryCost,
        adminFee: state => state.adminFee,
        discountThreshold: state => state.discountThreshold,
        minimumForDelivery: state => state.minimumForDelivery,
        location: state => state.location,
        websiteAvailability: state => state.websiteAvailability,
        discount: state => state.discount
      }),
      ...mapGetters([
        'getCartTotal',
        'getOrderType'
      ]),
      cartTotalBeforeAdminFee () {
        let total = this.getCartTotal

        if (this.discountThreshold < total) {
          if (this.discount.type === '%') {
            total = total - (total * this.discount.amount / 100)
          } else if (this.discount.type === '£') {
            total = this.discount.amount > total ? 0 : total - this.discount.amount
          }
        }

        return total + (this.orderType === 'collection' ? 0 : this.deliveryCost)
      },
      getCartFinalTotal () {
        const total = this.cartTotalBeforeAdminFee

        return total + (total < 10 && total > 0 ? this.adminFee : 0)
      },
      walletReady () {
        if (this.orderType === 'collection') {
          return true
        }

        return !!this.token
      },
      walletLabel () {
        if (this.walletType === 'applePay') {
          return 'Apple Pay'
        }
        if (this.walletType === 'googlePay') {
          return 'Google Pay'
        }
        return 'Apple Pay / Google Pay'
      },
      isGuestMode () {
        return !this.token && this.checkoutMode === 'guest' && this.orderType === 'collection'
      },
      showCardForm () {
        return this.hasCard !== null
      }
    },
    watch: {
      orderType (val) {
        kf.$store.dispatch('UpdateOrderType', val)
        if (val === 'delivery' && kf.checkoutMode === 'guest') {
          kf.checkoutMode = 'account'
        }
        kf.billingAsShipping = val === 'delivery'
        kf.destroyExpressCheckout()
        kf.$nextTick(kf.initializeExpressCheckout)
      },
      getCartFinalTotal () {
        if (expressElements) {
          expressElements.update({ amount: kf.walletAmount() })
        }
      }
    },
    created () {
      kf = this
      if (this.user) {
        this.firstName = this.user.first_name
        this.lastName = this.user.last_name
        this.email = this.user.email
        this.phone = this.user.phone
        this.address = this.user.address1
        this.postcode = this.user.postcode
        this.billing.address = this.user.address1
        this.billing.postcode = this.user.postcode
        this.billing.nameOnCard = `${this.user.first_name} ${this.user.last_name}`
      }
      kf.coupon_code = kf.discount.code ? kf.discount.code : null

      if (this.currentHour + '' + this.currentMinute < '1600') {
        this.orderType = 'collection'
      }

      this.billingAsShipping = this.orderType === 'delivery'
    },
    mounted () {
      this.initializePayment()
      this.initializeExpressCheckout()
    },
    methods: {
      deleteProductFromCart: (key) => {
        if (confirm('Are you sure you want to remove this product from the cart?')) {
          kf.cart.splice(key, 1)
          kf.$store.dispatch('UpdateCart', kf.cart)
        }
      },
      initializePayment () {
        if (kf.user) {
          kf.$store.dispatch('GetCustomerPaymentSources', kf.location.id)
            .then(response => {
              kf.sources = response.sources
              if (response.sources.length) {
                kf.placeOrderWithoutStripe()
                kf.hasCard = true
              } else {
                kf.initializeStripe()
              }
            })
            .catch(error => {
              console.log(error)
              kf.initializeStripe()
            })
        } else {
          kf.initializeStripe()
        }
      },
      initializeStripe () {
        // Create a Stripe client.
        kf.hasCard = false

        setTimeout(function () {
          // eslint-disable-next-line
          stripe = Stripe(kf.location.id === 1 ? env.stripe_token_location_1 : env.stripe_token_location_2)

          // Create an instance of Elements.
          let elements = stripe.elements({
            hidePostalCode: true,
            fonts: [
              {
                family: 'Muli',
                src: 'local("Muli Bold"), local("Muli-Bold"), url(https://fonts.gstatic.com/s/muli/v11/7Au_p_0qiz-adYnjOCX2z24PMFk.woff2) format("woff2")',
                style: 'normal',
                weight: 700,
                unicodeRange: 'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD'
              }
            ]
          })

          // Custom styling can be passed to options when creating an Element.
          // (Note that this demo uses a wider set of styles than the guide below.)
          let style = {
            base: {
              color: '#32325d',
              lineHeight: '18px',
              fontSmoothing: 'antialiased',
              fontFamily: '"Muli", Helvetica, sans-serif',
              fontSize: '14px',
              '::placeholder': {
                color: '#dfe2e4'
              }
            },
            invalid: {
              color: '#fa755a',
              iconColor: '#fa755a'
            }
          }

          // Create an instance of the card Element.
          card = elements.create('card', {
            hidePostalCode: true,
            style: style
          })

          // Add an instance of the card Element into the `card-element` <div>.
          card.mount('#card-element')

          // Handle real-time validation errors from the card Element.
          card.addEventListener('change', function (event) {
            let displayError = document.getElementById('card-errors')
            if (event.error) {
              displayError.textContent = event.error.message
            } else {
              displayError.textContent = ''
            }
          })

          // Handle form submission.
          let form = document.getElementById('payment-form')
          form.addEventListener('submit', kf.placeOrderWithStripeEvent, true)
        }, 300)
      },
      placeOrderWithStripeEvent (event) {
        event.preventDefault()

        if (kf.paymentType === 'wallet') {
          kf.notifyVue('danger', `Please use ${kf.walletLabel} to complete your order.`)
          return
        }

        if (kf.paymentType === 'wallet') {
          kf.notifyVue('danger', `Please use ${kf.walletLabel} to complete your order.`)
          return
        }

        const isGuest = kf.isGuestMode
        const guestName = kf.splitName(kf.billing.nameOnCard)

        kf.$store.dispatch('LoadingOn')

        kf.$store.dispatch('ManageCustomerInCheckout', {
          guest: isGuest,
          first_name: isGuest ? guestName.first : kf.firstName,
          last_name: isGuest ? guestName.last : kf.lastName,
          email: kf.email,
          phone: kf.phone,
          password: isGuest ? null : kf.password,
          password_confirmation: isGuest ? null : kf.passwordConfirmation,
          address: kf.address ? kf.address : (kf.billing.address ? kf.billing.address : null),
          postcode: kf.postcode ? kf.postcode : (kf.billing.postcode ? kf.billing.postcode : null),
          order_type: kf.orderType
        })
          .then((response) => {
            kf.placeOrderWithStripe(stripe, card, response)
          })
          .catch((error) => {
            console.log(error)
            kf.notifyVue('danger', 'Please check your details once again.')

            kf.formError = {
              firstName: error.errors.first_name ? error.errors.first_name.join(' ') : null,
              lastName: error.errors.last_name ? error.errors.last_name.join(' ') : null,
              email: error.errors.email ? error.errors.email.join(' ') : null,
              postcode: error.errors.postcode ? error.errors.postcode.join(' ') : null,
              phone: error.errors.phone ? error.errors.phone.join(' ') : null,
              password: error.errors.password ? error.errors.password.join(' ') : null,
              address: error.errors.address ? error.errors.address.join(' ') : null
            }

            console.log(error)

            kf.$store.dispatch('LoadingOff')
          })
      },
      placeOrderWithStripe (stripe, card, customer) {
        const shippingName = [kf.firstName, kf.lastName].filter(Boolean).join(' ')

        const extraDetails = {
          name: kf.billingAsShipping ? shippingName : kf.billing.nameOnCard,
          address_zip: kf.billingAsShipping && kf.orderType === 'delivery' ? kf.postcode : kf.billing.postcode,
          address_line1: kf.billingAsShipping && kf.orderType === 'delivery' ? kf.address : kf.billing.address,
          address_country: 'United Kingdom'
        }

        kf.billingError = {
          nameOnCard: extraDetails.name ? null : 'Name on card is missing.',
          postcode: extraDetails.address_zip ? null : 'Postcode is missing.',
          address: extraDetails.address_line1 ? null : 'Address is missing.'
        }

        if (kf.billingError.nameOnCard || kf.billingError.postcode || kf.billingError.address) {
          kf.$store.dispatch('LoadingOff')
          kf.notifyVue('danger', 'Please check your billing details.')

          return
        }

        stripe.createToken(card, extraDetails).then(function (result) {
          if (result.error) {
            // Inform the user if there was an error.
            let errorElement = document.getElementById('card-errors')
            errorElement.textContent = result.error.message
            kf.$store.dispatch('LoadingOff')
          } else {
            // Send the token to your server.
            if (typeof result.token === 'undefined' || result.token === null || result.token === '') {
              kf.notifyVue('danger', 'Something went wrong with your card. Please try again..')
              kf.$store.dispatch('LoadingOff')
              return
            }

            kf.$store.dispatch('PlaceOrder', {
              token: customer && customer.is_guest ? customer.token : undefined,
              stripe_token: result.token,
              save_card: customer && customer.is_guest ? false : kf.saveCard,
              expected_total: kf.getCartFinalTotal,
              order_type: kf.orderType,
              address: kf.deliveryAddress(),
              postcode: kf.deliveryPostcode(),
              cart: kf.cart,
              note: kf.note,
              discount: kf.discount,
              location: kf.location,
              payment_type: 'card'
            })
              .then((response) => {
                if (response.payment_intent.next_action && response.payment_intent.next_action.redirect_to_url) {
                  window.location = decodeURI(response.payment_intent.next_action.redirect_to_url.url)
                } else {
                  kf.$router.push(`/checkout-response?payment_intent=${response.payment_intent.id}`)
                }
              })
              .catch((error) => {
                if (error.message) {
                  kf.notifyVue('danger', error.message)
                  this.bottomError = error.message
                } else if (error.errors.length > 0) {
                  kf.paymentErrorMessage = error.errors.join(' ')
                } else {
                  kf.notifyVue('danger', 'Something went wrong. Please try again.')
                  this.bottomError = 'Something went wrong. Please try again.'
                }
                kf.$store.dispatch('LoadingOff')
              })
          }
        })
      },
      placeOrderWithoutStripe () {
        // Handle form submission.
        let form = document.getElementById('payment-form')
        form.addEventListener('submit', kf.placeOrderWithoutStripeForm, true)
      },
      placeOrderWithoutStripeForm (event) {
        event.preventDefault()
        kf.$store.dispatch('LoadingOn')

        kf.$store.dispatch('PlaceOrder', {
          expected_total: kf.getCartFinalTotal,
          order_type: kf.orderType,
          address: kf.deliveryAddress(),
          postcode: kf.deliveryPostcode(),
          cart: kf.cart,
          note: kf.note,
          discount: kf.discount,
          location: kf.location,
          payment_type: 'card'
        })
          .then((response) => {
            if (response.payment_intent.next_action && response.payment_intent.next_action.redirect_to_url) {
              window.location = decodeURI(response.payment_intent.next_action.redirect_to_url.url)
            } else {
              kf.$router.push(`/checkout-response?payment_intent=${response.payment_intent.id}`)
            }
          })
          .catch((error) => {
            if (error.message) {
              kf.notifyVue('danger', error.message)
              this.bottomError = error.message
            } else if (error.errors.length > 0) {
              kf.paymentErrorMessage = error.errors.join(' ')
            } else {
              kf.notifyVue('danger', 'Something went wrong. Please try again.')
              this.bottomError = 'Something went wrong. Please try again.'
            }
            kf.$store.dispatch('LoadingOff')
          })
      },
      addNewCard () {
        let form = document.getElementById('payment-form')
        form.removeEventListener('submit', kf.placeOrderWithoutStripeForm, true)
        kf.initializeStripe()
      },
      changePaymentType () {
        let form = document.getElementById('payment-form')

        setTimeout(function () {
          if (kf.paymentType === 'card') {
            form.removeEventListener('submit', kf.placeOrderWithPayByCash, true)
            kf.initializePayment()
          } else {
            form.removeEventListener('submit', kf.placeOrderWithStripeEvent, true)
            form.removeEventListener('submit', kf.placeOrderWithoutStripeForm, true)
            form.addEventListener('submit', kf.placeOrderWithPayByCash, true)
          }
        }, 100)
      },
      placeOrderWithPayByCash (event) {
        event.preventDefault()
        kf.$store.dispatch('LoadingOn')

        kf.$store.dispatch('ManageCustomerInCheckout', {
          first_name: kf.firstName,
          last_name: kf.lastName,
          email: kf.email,
          phone: kf.phone,
          password: kf.password,
          password_confirmation: kf.passwordConfirmation,
          address: kf.address ? kf.address : (kf.billing.address ? kf.billing.address : null),
          postcode: kf.postcode ? kf.postcode : (kf.billing.postcode ? kf.billing.postcode : null),
          order_type: kf.orderType
        })
          .then((response) => {
            kf.$store.dispatch('PlaceOrder', {
              expected_total: kf.getCartFinalTotal,
              order_type: kf.orderType,
              address: kf.deliveryAddress(),
              postcode: kf.deliveryPostcode(),
              cart: kf.cart,
              note: kf.note,
              discount: kf.discount,
              location: kf.location,
              payment_type: 'cash'
            })
              .then((response) => {
                kf.$router.push(`/checkout-response?order_number=${response.order_number}`)
              })
              .catch((error) => {
                if (error.message) {
                  kf.notifyVue('danger', error.message)
                  this.bottomError = error.message
                } else {
                  kf.notifyVue('danger', 'Something went wrong. Please try again.')
                  this.bottomError = 'Something went wrong. Please try again.'
                }
                kf.$store.dispatch('LoadingOff')
              })
          })
          .catch((error) => {
            console.log(error)
            kf.notifyVue('danger', 'Please check your details once again.')

            kf.formError = {
              firstName: error.errors.first_name ? error.errors.first_name.join(' ') : null,
              lastName: error.errors.last_name ? error.errors.last_name.join(' ') : null,
              email: error.errors.email ? error.errors.email.join(' ') : null,
              postcode: error.errors.postcode ? error.errors.postcode.join(' ') : null,
              phone: error.errors.phone ? error.errors.phone.join(' ') : null,
              password: error.errors.password ? error.errors.password.join(' ') : null,
              address: error.errors.address ? error.errors.address.join(' ') : null
            }

            console.log(error)

            kf.$store.dispatch('LoadingOff')
          })
      },
      applyCoupon () {
        if (kf.coupon_code === null || kf.coupon_code === '') {
          kf.notifyVue('danger', 'Please enter a discount code.')
          return
        }

        kf.$store.dispatch('GetDiscount', kf.coupon_code)
          .then(response => {
            kf.notifyVue('success', 'You successfully applied your coupon.')
          })
          .catch(error => {
            kf.notifyVue('danger', error.errors.length ? error.errors[0] : 'Something went wrong. Please try again.')
          })
      },
      plusProductQuantity (index) {
        let product = kf.cart[index]

        product.quantity++
        kf.cart[index] = product

        kf.$store.dispatch('UpdateCart', kf.cart)
      },
      minusProductQuantity (index) {
        let product = kf.cart[index]

        if (product.quantity > 1) {
          product.quantity--
          kf.cart[index] = product

          kf.$store.dispatch('UpdateCart', kf.cart)
        }
      },
      deliveryAddress () {
        return kf.address ? kf.address : (kf.user && kf.user.address1 ? kf.user.address1 : null)
      },
      deliveryPostcode () {
        return kf.postcode ? kf.postcode : (kf.user && kf.user.postcode ? kf.user.postcode : null)
      },
      walletAmount () {
        return Math.round(kf.getCartFinalTotal * 100)
      },
      initializeExpressCheckout () {
        if (env.wallet_enabled === false || !kf.cart.length || !kf.walletReady) {
          return
        }

        // eslint-disable-next-line
        expressStripe = Stripe(kf.location.id === 1 ? env.stripe_token_location_1 : env.stripe_token_location_2)

        expressElements = expressStripe.elements({
          mode: 'payment',
          amount: kf.walletAmount(),
          currency: 'gbp',
          paymentMethodTypes: ['card'],
          appearance: {
            variables: {
              fontFamily: '"Muli", Helvetica, sans-serif'
            }
          }
        })

        expressCheckout = expressElements.create('expressCheckout', {
          buttonHeight: 48,
          business: { name: 'KungFood' },
          emailRequired: true,
          phoneNumberRequired: true,
          billingAddressRequired: true,
          shippingAddressRequired: false,
          paymentMethods: {
            applePay: 'auto',
            googlePay: 'auto',
            link: 'never',
            paypal: 'never',
            amazonPay: 'never'
          },
          layout: {
            maxColumns: 2,
            overflow: 'never'
          }
        })

        expressCheckout.on('ready', function (event) {
          const available = event && event.availablePaymentMethods

          kf.canUseWallet = !!available

          if (!available) {
            kf.paymentType = 'card'
            return
          }

          kf.walletType = available.applePay ? 'applePay' : (available.googlePay ? 'googlePay' : null)
        })

        expressCheckout.on('loaderror', function (event) {
          kf.canUseWallet = false
        })

        expressCheckout.on('click', function (event) {
          event.resolve({})
        })

        expressCheckout.on('confirm', kf.handleExpressCheckoutConfirm)

        expressCheckout.mount('#express-checkout-element')
      },
      destroyExpressCheckout () {
        if (expressCheckout) {
          expressCheckout.unmount()
        }

        expressCheckout = null
        expressElements = null
        kf.canUseWallet = false
      },
      splitName (fullName) {
        const parts = (fullName || '').trim().split(/\s+/).filter(Boolean)
        const first = parts.shift() || null

        return { first: first, last: parts.length ? parts.join(' ') : first }
      },
      handleExpressCheckoutConfirm (event) {
        kf.$store.dispatch('LoadingOn')

        expressElements.submit()
          .then(function (result) {
            if (result.error) {
              throw result.error
            }

            const billingDetails = event.billingDetails || {}
            const name = kf.splitName(billingDetails.name)
            const isGuest = !kf.token && kf.orderType === 'collection' && (kf.isGuestMode || !kf.password)

            let address = kf.address ? kf.address : (kf.billing.address ? kf.billing.address : null)
            let postcode = kf.postcode ? kf.postcode : (kf.billing.postcode ? kf.billing.postcode : null)

            if (billingDetails.address) {
              address = address || [billingDetails.address.line1, billingDetails.address.line2].filter(Boolean).join(', ') || null
              postcode = postcode || billingDetails.address.postal_code || null
            }

            return kf.$store.dispatch('ManageCustomerInCheckout', {
              guest: isGuest,
              first_name: kf.firstName ? kf.firstName : name.first,
              last_name: kf.lastName ? kf.lastName : name.last,
              email: kf.email ? kf.email : billingDetails.email,
              phone: kf.phone ? kf.phone : billingDetails.phone,
              password: isGuest ? null : kf.password,
              password_confirmation: isGuest ? null : kf.passwordConfirmation,
              address: address,
              postcode: postcode,
              order_type: kf.orderType
            })
              .then(function (customer) {
                return kf.$store.dispatch('PlaceOrder', {
                  token: customer && customer.is_guest ? customer.token : undefined,
                  deferred_payment: true,
                  save_card: false,
                  expected_total: kf.getCartFinalTotal,
                  order_type: kf.orderType,
                  address: kf.deliveryAddress(),
                  postcode: kf.deliveryPostcode(),
                  cart: kf.cart,
                  note: kf.note,
                  discount: kf.discount,
                  location: kf.location,
                  payment_type: 'card'
                })
              })
          })
          .then(function (response) {
            return expressStripe.confirmPayment({
              elements: expressElements,
              clientSecret: response.payment_intent.client_secret,
              confirmParams: {
                return_url: `${window.location.origin}/checkout-response`
              },
              redirect: 'if_required'
            })
          })
          .then(function (confirmation) {
            if (confirmation.error) {
              throw confirmation.error
            }

            kf.$router.push(`/checkout-response?payment_intent=${confirmation.paymentIntent.id}`)
          })
          .catch(function (error) {
            kf.$store.dispatch('LoadingOff')

            if (typeof event.paymentFailed === 'function') {
              event.paymentFailed({ reason: 'fail' })
            }

            if (error && error.message) {
              kf.notifyVue('danger', error.message)
            } else if (error && error.errors && error.errors.length > 0) {
              kf.paymentErrorMessage = error.errors.join(' ')
            } else {
              kf.notifyVue('danger', 'Something went wrong. Please try again.')
            }
          })
      },
      notifyVue (type, message) {
        this.$notifications.notify({
          message: message,
          icon: '',
          horizontalAlign: 'right',
          verticalAlign: 'bottom',
          type: type
        })
      }
    }
  }
</script>

<style>
  .wallet-hint {
    margin-bottom: 15px;
    color: #98a1a8;
    font-size: 13px;
  }
  .guest-note {
    margin: 0 0 15px;
  }
  #checkoutModeBoxes, #paymentTypeBoxes {
    margin-bottom: 15px;
  }
  #express-checkout-element {
    height: auto;
    max-width: 180px;
    padding: 0;
    background-color: transparent;
    border: 0;
    border-radius: 0;
    box-shadow: none;
  }
  .express-divider {
    position: relative;
    text-align: center;
    margin: 20px 0 25px;
  }
  .express-divider:before {
    content: '';
    position: absolute;
    top: 50%;
    left: 0;
    right: 0;
    border-top: 1px solid #e3e3e3;
  }
  .express-divider span {
    position: relative;
    padding: 0 12px;
    background: #f4f3ef;
    color: #98a1a8;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// checkout.vue?3a5a3280